import { Routes } from "@angular/router";
import { canvasResolver } from "./resolvers/canvas.resolver";

export const routes: Routes = [
    {
        path: "",
        pathMatch: "full",
        redirectTo: "no-canvas",
    },
    {
        path: "no-canvas",
        loadComponent: () =>
            import("./components/no-canvas/no-canvas").then((m) => m.NoCanvas),
    },
    {
        path: "not-found",
        loadComponent: () =>
            import("./components/not-found/not-found").then((m) => m.NotFound),
    },
    {
        path: "out-of-units",
        loadComponent: () =>
            import("./components/out-of-units/out-of-units").then(
                (m) => m.OutOfUnits
            ),
    },
    {
        path: "embed/:canvasId",
        loadComponent: () =>
            import("./components/embed-viewer/embed-viewer").then(
                (m) => m.EmbedViewer
            ),
        resolve: { canvas: canvasResolver },
    },
    {
        path: ":canvasId",
        resolve: { canvas: canvasResolver },
        loadComponent: () =>
            import("./components/canvas-viewer/canvas-viewer").then(
                (m) => m.CanvasViewer
            ),
    },
];
